export default __webpack_public_path__ + "static/media/McDs.76c8ce78.gif";